export class TemplateLoader {
    constructor() {
        Object.defineProperty(this, "cached", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    async load() {
        if (this.cached)
            return this.cached;
        const response = await fetch('/templates.json');
        if (!response.ok) {
            throw new Error(`Failed to load templates.json: ${response.status}`);
        }
        this.cached = (await response.json());
        return this.cached;
    }
}
